import { render, staticRenderFns } from "./previewFormbuilderTemplate.vue?vue&type=template&id=fea203ce&scoped=true"
import script from "./previewFormbuilderTemplate.vue?vue&type=script&lang=js"
export * from "./previewFormbuilderTemplate.vue?vue&type=script&lang=js"
import style0 from "./previewFormbuilderTemplate.vue?vue&type=style&index=0&id=fea203ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea203ce",
  null
  
)

export default component.exports